import Page from '../Page'
import Home from '../pages/Homepage'
import About from '../pages/About'
import PackageEng from '../pages/PackageEng'
import PackageIta from '../pages/PackageIta'
import BeSmart from '../pages/BeSmart'
import Contact from '../pages/Contact'
import Collection from '../pages/Collection'
import WineCollection from '../pages/WineCollection'
import translations from '../translations'

const locales = [ 'en', 'it' ];
const names = [
    {
        name: 'home',
        component: Home
    }, {
        name: 'about',
        component: About
    }, {
        name: 'steelKeg',
        component: PackageIta
    }, {
        name: 'keyKeg',
        component: PackageEng
    }, {
        name: 'collection',
        component: Collection
    }, {
        name: 'be_smart',
        component: BeSmart,
        meta: { headerShadow: true }
    }, {
        name: 'contact',
        component: Contact,
        meta: { headerNoScroll: true }
    }, /* {
        name: 'privacy',
        component: ''
    }, {
        name: 'cookie',
        component: ''
}*/];

function getRoutePath( locale, route ) {
    return translations[locale]['routes'][route];
}

export default function() {
    let computed = [];

    for( let locale of locales ) {
        let route = {
            path: '/'+locale,
            component: Page,
            children: [],
        }

        for( let name of names  ) {

            route['children'].push({
                path: ( name.name === 'home' ) ? '/' : '/'+locale+'/' + getRoutePath( locale, name.name ),
                name: locale+'.'+name.name,
                component: name.component,
                meta: ( name.meta ) ? name.meta : null
            })

            if( name.name === 'collection' ) {
                route['children'].push({
                    path: '/'+locale+'/' + getRoutePath( locale, name.name )+'/:wine', // /en/the-collection/sparkling-wines
                    name: locale+'.'+name.name+'.wine',
                    component: WineCollection
                })
            }
        }
        computed.push( route )
    }

    computed.push({
        name: 'disclaimer',
        path: '/disclaimer',
        component: require('../pages/Disclaimer').default
    });
    computed.push({
        path: '*',
        component: require('../pages/NotFound').default
    });

    return computed;
}